import { useEffect, useRef } from 'react'

import { editScheduleListActions } from '../actions'
import { useEditScheduleEditorOperations, useAlertClassIds } from '../hooks'
import { getClassId, getLesson } from '../utils/lessonHelpers'
import { groupScheduleByDate } from '../../schedule/utils/groupScheduleByDate'
import { useActions, useAppSelector } from '../../../store/hooks'
import { editSchedulePageSelector } from '../../../store/slices/editSchedulePage'
import { scheduleSelector } from '../../../store/slices/schedule'

export function useEditScheduleList() {
    const editorRef = useRef(null)

    const { alertClassIds } = useAlertClassIds()

    const schedule = useAppSelector(scheduleSelector.items)
    const loadingSchedule = useAppSelector(scheduleSelector.isLoading)
    const totalItems = useAppSelector(scheduleSelector.total)
    const editingId = useAppSelector(editSchedulePageSelector.editingId)
    const isCreating = useAppSelector(editSchedulePageSelector.isCreating)
    const currentPage = useAppSelector(editSchedulePageSelector.currentPage)
    const pageSize = useAppSelector(editSchedulePageSelector.pageSize)

    const { setPagination, setShowDeleteModal } = useActions(editScheduleListActions)
    const { openEditEditor } = useEditScheduleEditorOperations()

    const entries = groupScheduleByDate(schedule)

    useEffect(() => {
        if ((isCreating || editingId) && editorRef.current) {
            editorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }, [isCreating, editingId])

    const changePage = (nextPage, nextSize) => {
        if (nextSize !== pageSize) {
            setPagination({ page: 1, pageSize: nextSize })
            return
        }

        setPagination({ page: nextPage })
    }

    const changePageSize = (_current, nextSize) => {
        setPagination({ page: 1, pageSize: nextSize })
    }

    const handleDelete = (classId) => {
        setShowDeleteModal({ open: true, classId })
    }

    return {
        alertClassIds,
        entries,
        loadingSchedule,
        totalItems,
        editingId,
        isCreating,
        currentPage,
        pageSize,
        editorRef,
        openEditEditor,
        handleDelete,
        changePage,
        changePageSize,
    }
}

export function isEditingLesson(item, editingId) {
    const lesson = getLesson(item)
    const classId = getClassId(item, lesson)

    return String(editingId) === String(classId)
}
